// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__2axOh","content":"Header_content__1bWFE","brandLogo":"Header_brandLogo__161AX"};